import React from "react";
import { Disclosure } from "@headlessui/react";
import { Link } from "react-router-dom";
import {
  Bars3BottomLeftIcon,
  BellIcon,
  ArrowRightOnRectangleIcon,
  XMarkIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import logo909 from "../assets/icons/909.png";
import logoLC7 from "../assets/icons/LC7.png";
import logo777 from "../assets/icons/777.png";
import logoAdmin from "../assets/icons/adminHub.png";
import logoMoneyBall from "../assets/icons/moneyBall.png";
import logoEP from "../assets/icons/epsport.png";
import { FaSun,FaMoon  } from "react-icons/fa6";
import { selectUserData } from "../reducers/user.reducer";

const user = {
  name: "Tom Cook",
  email: "tom@example.com",
  imageUrl:
    "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
};

const navigation = [
  { name: "Dashboard", route: "/dashboard" },
  { name: "Check Odd", route: "/check-odd" },
  { name: "Different Odd", route: "/diff-odd" },
  { name: "Match Event", route: "/match-event" },
  { name: "Limit", route: "/gambling-limit" },
  { name: "Result List",route:"/goal-result"},
  { name: "Insert Result", route: "/insert-result" },
  { name: "By Event", route: "/report-byevent" },
  { name: "By Mix", route: "/report-bymix" },
  { name: "By Purchased", route: "/report-bypurchased" },
  { name: "By Date",route:"/transaction-bydate"},
  { name: "By Voucher",route:"/by-voucher"}
];

const userNavigation = [
  { name: "Settings", route: "/settings" },
  {
    name: "Sign out",
    route: "/login",
    onclick: () => {
      sessionStorage.clear();
    },
  },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const logoMapping = {
  "909": logo909,
  LC7: logoLC7,
  MNB: logoMoneyBall,
  "777": logo777,
  EP: logoEP,
};

const navBorderMapping = {
  "909": "border-b-customAccent",
  LC7: "border-b-customFontGold",
  MNB: "border-b-customDarkGreen",
  "777": "border-b-customOrange",
  EP: "border-b-customFontRed",
};

const iconButtonClasses =
  "relative inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:border-customAccent hover:text-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/40 dark:border-customBorder/70 dark:bg-custom_dark_primary dark:text-customMuted dark:hover:text-customHeading";

function ThemeToggleButton({ darkMode, onToggle }) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={darkMode ? "Light mode" : "Dark mode"}
      className={iconButtonClasses}
    >
      {darkMode ? (
        <FaSun className="h-4 w-4 text-amber-400" aria-hidden="true" />
      ) : (
        <FaMoon className="h-4 w-4 text-customAccent" aria-hidden="true" />
      )}
    </button>
  );
}

function Navbar({ setShowSideBar, onlyWidth, setDarkMode, darkMode }) {
  const { userDetails, companyInfo } = useSelector(selectUserData) || {};
  const activeCompany = companyInfo || {};
  const companyId = activeCompany?.companyId || userDetails?.companyId;
  const companyName = activeCompany?.companyName || (companyId ? `${companyId} Admin HUB` : "Admin HUB");
  const companyLogo = logoMapping[companyId] || logoAdmin;
  const navBorderClass = navBorderMapping[companyId] || "border-b-slate-200 dark:border-b-customBorder";
  const invalidItem = companyId === "LC7" ? ["Check Odd","Different Odd","Match Event","Result List",""] : [];

  const handleThemeToggle = () => {
    setDarkMode((prev) => !prev);
  };

  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
  }

  return (
    <Disclosure
      as="nav"
      className={classNames(
        "sticky top-0 z-40 border-b-2 bg-white/95 shadow-sm backdrop-blur dark:bg-custom_dark_primary2/95",
        navBorderClass
      )}
    >
      {({ open }) => (
        <>
          <div className="mx-auto px-1 sm:px-6">
            <div className="flex h-12 items-center justify-between">
              <div className="flex items-center">
                <div className="flex-shrink-0 md:block hidden">
                  <button
                    type="button"
                    onClick={() => setShowSideBar((show) => !show)}
                    aria-label="Toggle sidebar"
                    className="inline-flex h-9 w-9 items-center justify-center rounded-lg text-slate-600 transition hover:bg-slate-100 hover:text-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/40 dark:text-customMuted dark:hover:bg-custom_dark_primary dark:hover:text-customHeading"
                  >
                    <Bars3BottomLeftIcon
                      className="block h-6 w-6"
                      aria-hidden="true"
                    />
                  </button>
                </div>
                <div className="flex-shrink-0 ml-5 flex items-center gap-2">
                 {onlyWidth < 768 ? 
                  <img
                    className="h-8 w-8 rounded-md object-contain"
                    src={companyLogo}
                    alt={companyName}
                  /> : null
                }
                  <span className={`${onlyWidth > 768 ? 'text-base' : 'text-sm'} font-bold text-customInk dark:text-customHeading`}>{companyName}</span>
                </div>
                {/* <div className="hidden md:block">
                  <div className="ml-10 flex items-baseline space-x-4">
                    {navigation.map((item) => (
                      <Link
                        key={item.name}
                        to={item.route}
                        className={classNames(
                          location.pathname === item.route
                            ? "bg-gray-800 text-white"
                            : "text-gray-300 hover:bg-gray-700 hover:text-white",
                          "rounded-md px-3 py-2 text-sm font-medium"
                        )}
                      >
                        <span>{item.name}</span>
                      </Link>
                    ))}
                  </div>
                </div> */}
              </div>
              <div className="hidden md:block">
                <div className="ml-4 flex gap-3 items-center md:ml-6">
                  <ThemeToggleButton darkMode={darkMode} onToggle={handleThemeToggle} />
                  <button
                    type="button"
                    className={iconButtonClasses}
                    aria-label="View notifications"
                  >
                    <BellIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  <button
                    type="button"
                    onClick={() => handleLogout()}
                    className={iconButtonClasses}
                    aria-label="Sign out"
                  >
                    <ArrowRightOnRectangleIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                  <img
                    className="h-8 w-8 rounded-full ring-2 ring-slate-200 dark:ring-customBorder"
                    src={user.imageUrl}
                    alt=""
                  />
                  <span className="text-base font-semibold text-customInk dark:text-customHeading">{userDetails?.username}</span>
                  {/* Profile dropdown */}
                  {/* <MenuHeadUI as="div" className="relative ml-3">
                    <div>
                      <MenuHeadUI.Button className="relative flex max-w-xs items-center rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span className="absolute -inset-1.5" />
                        <span className="sr-only">Open user menu</span>
                        <img
                          className="h-8 w-8 rounded-full"
                          src={user.imageUrl}
                          alt=""
                        />
                      </MenuHeadUI.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <MenuHeadUI.Items className="absolute right-0 z-[900] mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        {userNavigation.map((item) => (
                          <MenuHeadUI.Item key={item.name}>
                            {({ active }) => (
                              <a
                                href={item.route}
                                className={classNames(
                                  active ? "bg-gray-100" : "",
                                  "block px-4 py-2 text-sm text-gray-700"
                                )}
                              >
                                {item.name}
                              </a>
                            )}
                          </MenuHeadUI.Item>
                        ))}
                      </MenuHeadUI.Items>
                    </Transition>
                  </MenuHeadUI> */}
                </div>
              </div>
              <div className="hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                  <span className="absolute -inset-0.5" />
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <EllipsisVerticalIcon
                      className="block h-6 w-6"
                      aria-hidden="true"
                    />
                  )}
                </Disclosure.Button>
              </div>
              <div className="md:hidden">
                <div className="flex items-center gap-2">
                  <ThemeToggleButton darkMode={darkMode} onToggle={handleThemeToggle} />
                   <button
                    type="button"
                    className={iconButtonClasses}
                    aria-label="View notifications"
                  >
                    <BellIcon className="h-5 w-5" aria-hidden="true" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="hidden">
            <div className="space-y-1 px-2 pb-3 pt-2 sm:px-3">
              {navigation.filter(a => !invalidItem.includes(a.name)).map((item) => (
                <Disclosure.Button
                  key={item.name}
                  // as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-800 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block rounded-md text-base font-medium w-full"
                  )}
                  // aria-current={item.current ? "page" : undefined}
                >
                  <Link
                    to={item.route}
                    className="w-full h-full flex px-3 py-2"
                  >
                    <span>{item.name}</span>
                  </Link>
                </Disclosure.Button>
              ))}
            </div>
            <div className="border-t border-gray-700 pb-3 pt-4">
              <div className="flex items-center px-5">
                <div className="flex-shrink-0">
                  <img
                    className="h-10 w-10 rounded-full"
                    src={user.imageUrl}
                    alt=""
                  />
                </div>
                <div className="ml-3">
                  <div className="text-base font-medium leading-none text-white">
                    {userDetails?.username}
                  </div>
                  <div className="text-sm font-medium leading-none text-gray-400">
                    {companyId}
                  </div>
                </div>
                <button
                  type="button"
                  className="relative ml-auto flex-shrink-0 rounded-full bg-gray-800 p-1 text-gray-400 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800"
                >
                  <span className="absolute -inset-1.5" />
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="mt-3 space-y-1 px-2 z-50">
                {userNavigation.map((item) => (
                   <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.route}
                    className="block rounded-md px-3 py-2 text-base font-medium text-gray-400 hover:bg-gray-700 hover:text-white"
                  >
                    {item.name}
                    </Disclosure.Button>
                ))}
              </div>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}

export default Navbar;
